import { PalletStatusType } from "../../../../front-office/constants/constants";

export class GetPalletsByStatusQuery {
    private readonly _warehouseCode: string;
    private readonly _status: PalletStatusType;

    constructor(warehouseCode: string, status: PalletStatusType) {
        this._warehouseCode = warehouseCode;
        this._status = status;
    }

    get warehouseCode() {
        return this._warehouseCode;
    }

    get status() {
        return this._status;
    }
}
